import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import { filterSubPaymentMethodsByProduct } from '../../utils/payments';
const SubPaymentMethodsSideComponent = (props) => {
  const [subPaymentMethods, setSubPaymentMethods] = useState(null);

  useEffect(() => {
    if (!props.subPaymentMethods) {
      props.getSubPaymentMethods({ paymentMethod: props.paymentMethod });
    }
  }, [props.getSubPaymentMethods]);

  useEffect(() => {
    if (props.subPaymentMethods?.length > 0) {
      setSubPaymentMethods(props.subPaymentMethods);
      if (props.isSingleSubscriptionClient) {
        const filteredMethods = filterSubPaymentMethodsByProduct(
          props.planSelected,
          props.subPaymentMethods,
          props.userData?.country,
          props.paymentMethod
        );
        setSubPaymentMethods(filteredMethods);
      }
    }
  }, [
    props.subPaymentMethods?.length,
    props.isSingleSubscriptionClient,
    props.planSelected,
    props.userData?.country
  ]);

  return (
    <div className="SubPaymentMethodsSideComponent">
      <Row>
        <Col md={12}>
          <h5 className="summary-title">
            <FormattedMessage
              id="PaymentMethodSelector.SideComponent.title"
              defaultMessage="Métodos de pago disponibles"
            />
          </h5>
        </Col>
      </Row>
      {subPaymentMethods && (
        <Row className="PaymentMethodSelector__container">
          <>
            {subPaymentMethods.length > 0 && (
              <Col md={12} className="PaymentMethodSelector__logos">
                {subPaymentMethods.map((subPaymentMethod, index) => (
                  <div
                    className="PaymentMethodSelector__image-contianer"
                    key={index}
                    onClick={() => {
                      const types = { CARD: 'card', BANK_TRANSFER: 'bank', TICKET: 'ticket' };
                      props.setCurrentSubPaymentMethod(subPaymentMethod);
                      props.history.push(`methods/${subPaymentMethod.paymentMethod}/${types[subPaymentMethod.type]}` + window.location.search);
                    }}
                  >
                    <div
                      className="PaymentMethodSelector__image"
                      style={{ backgroundImage: `url(${subPaymentMethod.logo})` }}
                    />
                    <p>{subPaymentMethod.name}</p>
                  </div>
                ))}
              </Col>
            )}
            {subPaymentMethods.length === 0 && (
              <Col md={12} className="PaymentMethodSelector__NoPaymentMethods--contianer">
                <p className="PaymentMethodSelector__NoPaymentMethods--text">
                  <FormattedMessage
                    id="PaymentMethodSelector.SideComponent.noPaymentMethods"
                    defaultMessage="No tiene métodos de pago disponibles."
                  />
                </p>
              </Col>
            )}
          </>
        </Row>
      )}
    </div>
  );
}

SubPaymentMethodsSideComponent.propTypes = {
  subPaymentMethods: PropTypes.array,
  getSubPaymentMethods: PropTypes.func.isRequired,
  paymentMethod: PropTypes.string.isRequired,
  setCurrentSubPaymentMethod: PropTypes.func.isRequired,
  isSingleSubscriptionClient: PropTypes.bool.isRequired,
  planSelected: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default SubPaymentMethodsSideComponent;
